import { track } from './analytics';

$(() => {

    let pdfInterval = {};

    $(document).on('click', '.get-pdf', function (e) {
        e.preventDefault();

        const getBtn = $(this);
        const id = getBtn.data('id');

        if (getBtn.hasClass('blinking')) {
            return;
        }

        getBtn.addClass('blinking');
        track('report_download');

        $.ajax({
            method: 'POST',
            headers: {Accept: 'application/json'},
            url: getPdfUrl,
            data: {hash: id},
            success: json => {
                console.log(json)
                if (json.success) {
                    pdfInterval[id] = {func: setInterval(checkPdf, 3000, id), cnt: 0};
                }
            },
        });
    });

    if (!window.sticker) {
        let id = $('#report-id').val();
        $.ajax({
            method: 'POST',
            url: window.windowStickerUrl,
            data: {reportId: id},
            success: function (response) {
                if (!response.html) {
                    return;
                }

                $('.hide-sticker-item').removeClass('hide-sticker-item');
                $('#sticker-cont').html(response.html);
            },
            error: function (error) {
                console.log(error);
            },
        });
    }

    function downloadURI(uri, name) {
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

        // A full report is thirty-odd pages of photographs and takes the renderer around twenty
    // seconds; ten polls at three seconds gave up at thirty and left the customer with a button
    // that had simply stopped blinking. Forty polls is two minutes, which is longer than any
    // render we have measured and still bounded.
    const PDF_POLL_LIMIT = 40;
const checkPdf = (id) => {
        let getBtn = $(`.get-pdf[data-id='${id}']`);

        if (!pdfInterval.hasOwnProperty(id)) {
            return;
        }

        if (pdfInterval[id]['cnt'] > PDF_POLL_LIMIT) {
            clearInterval(pdfInterval[id]['func']);
            delete pdfInterval[id];
            getBtn.removeClass('blinking');
        }

        $.ajax({
            method: 'POST',
            headers: {Accept: 'application/json'},
            url: checkPdfUrl,
            data: {hash: id},
            success: json => {
                console.log(json)
                if (json.success) {
                    if (pdfInterval.hasOwnProperty(id)) {
                        clearInterval(pdfInterval[id]['func']);
                    }
                    delete pdfInterval[id];

                    getBtn.removeClass('blinking');
                    getBtn.removeClass('get-pdf');
                    getBtn.attr('href', json.link);
                    getBtn.attr('target', '_blank');
                    downloadURI(json.link, 'report.pdf')

                } else {
                    if (pdfInterval.hasOwnProperty(id)) {
                        pdfInterval[id]['cnt']++;
                    }
                }
            },
            error: response => {
            },
            complete: response => {
            },
        });
    }

    $(document).on('click', '#take-report:not(.disabled)', function (e) {
        e.preventDefault();
        $(this).addClass('disabled');
        let id = $('#report-id').val();
        $.ajax({
            method: 'POST',
            url: window.takeReportUrl,
            data: {reportId: id},
            success: function (response) {
                if (response.success) {
                    let alert = $('#take-alert');
                    $(alert).find('.alert-text').text(response.message);
                    $('.prepaid-qty').text(response.qty);
                    $('#take-report').remove();
                    setTimeout(function () {
                        $(alert).fadeOut(300, function () {
                            $(alert).remove();
                        });
                    }, 4000);
                }
            },
            error: function (error) {
                console.log(error);
            },
        });
    });

    $(document).on('click', '.show-btn', function (e) {
        $(this).hide(100);
        e.preventDefault();
        let fh = $(this).siblings('.show-more');
        fh.data('height', fh.height()).css('height', 'auto').data('full-height', fh.height()).height(fh.data('height')).animate({height: fh.data('full-height')}, 300, function () {
            fh.css('height', 'auto').parents('.rep-table').addClass('open');
        });
    });

    $(document).on('click', '.show-specs-btn', function (e) {
        $(this).hide(100).parents('.specs-row').addClass('show');
    });

    const sizesR = [

        {
            breakpoint: 1250,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1160,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ];

    const isPrint = new URLSearchParams(window.location.search).has('print');
    const $carSlider = $('.car-slider');

    if (!isPrint) {
        $carSlider.slick({
            infinite: false,
            autoplay: true,
            speed: 350,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            autoplaySpeed: 5000,
            centerMode: false,
            touchThreshold: 100,
            responsive: sizesR,
        });
    } else {
        if ($carSlider.hasClass('slick-initialized')) {
            $carSlider.slick('unslick');
        }
        $carSlider.removeClass('slick-slider').addClass('d-flex flex-wrap');
        $carSlider.children('div').addClass('col-3').addClass('mx-0').addClass('px-1').addClass('mb-2').removeClass('m-1');
    }

    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
        // A hidden section (Sales history waiting for its AI damage cards) reports offset 0.
        let target = $(this.hash).filter(':visible');
        // Some outline tiles always render but their section does not — "Sales history" with no
        // auction records, "Owners" with no ownership data. Falling through to the browser sent
        // the reader to the top of the report; swallowing the click leaves them where they are.
        if (!target.length) {
            return false;
        }
        $('html, body').stop().animate({
            scrollTop: (target.offset().top - 56),
        }, 600);
        return false;
    });
    $('body').scrollspy({
        target: '#rep-menu',
        offset: 80,
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });

    showAllEquipment();
});

// The membership offer is on the page only for a reader it applies to (ReportAccess::membershipOffer).
// As on EpicVIN, it opens once per page view, when they reach the sales history — or the recalls in a
// report without one. A ready handler of its own, so the one above throwing (showAllEquipment, on a
// report with no equipment list) cannot stop it. It listens on document, not on window as EpicVIN
// does: app.js's document scroll handler returns false on every page without the sticky VIN form,
// this one included, and that stops the event before it reaches window.
$(() => {
    const modal = $('#unlim-modal');
    if (!modal.length) {
        return;
    }

    // Looked up on every scroll: the sales history can be hidden while it waits for its AI damage
    // cards (a hidden element's offset is 0, which opened the modal at once) and appear later.
    const openWhenReached = () => {
        const sales = $('#sales:visible');
        const section = sales.length ? sales : $('#recalls');
        if (section.length && $(window).scrollTop() + 200 > section.offset().top) {
            $(document).off('scroll', openWhenReached);
            modal.modal('show');
        }
    };
    $(document).on('scroll', openWhenReached);
});

// AI damage cards. Ready ones are rendered with the report; while epicvin is still analysing lots
// the section carries data-ai-pending and the rest are polled for.
$(() => {
    const isPrint = new URLSearchParams(window.location.search).has('print');
    const section = $('#sales');
    const list = section.find('.sale-record-list');
    let scriptRequested = false;
    let scriptFailed = false;
    const failDamage3d = () => $('.damage3d:not(.is-init)').addClass('is-init is-failed');

    const initDamage3d = () => {
        if (window.initDamage3d) {
            window.initDamage3d();
            return;
        }
        if (scriptFailed) {
            failDamage3d();
            return;
        }
        if (scriptRequested || !window.damage3dUrl) {
            return;
        }
        scriptRequested = true;
        const script = document.createElement('script');
        script.src = window.damage3dUrl;
        script.onerror = () => {
            scriptFailed = true;
            console.error('damage-3d: bundle failed to load', window.damage3dUrl);
            failDamage3d();
        };
        document.body.appendChild(script);
    };

    if (isPrint || !list.length) {
        return;
    }
    list.find('.damage3d').length && initDamage3d();
    if (!section.is('[data-ai-pending]') || !window.aiDamageUrl) {
        return;
    }

    const reportId = $('#report-id').val();
    let tries = 0;
    let errors = 0;

    // Only beside records already on screen: on its own the spinner would have to open the
    // section, under a heading counting records that may never come.
    if (list.find('.sale-record').length) {
        const pending = $('<div class="pan mb-4 brd-gr sale-record--pending"><span class="sale-record__pending-spinner"></span><p class="sale-record__pending-text"></p></div>');
        pending.find('.sale-record__pending-text').text(window.aiDamagePendingText || '');
        list.append(pending);
    }
    const settle = () => list.find('.sale-record--pending').remove();

    const insert = (html) => {
        $($.parseHTML(html.trim())).filter('.sale-record').each(function () {
            const card = $(this);
            const key = card.attr('data-lot-key');
            const present = list.find('.sale-record').filter(function () {
                return this.getAttribute('data-lot-key') === key;
            });
            if (key && present.length) {
                return;
            }
            const ts = parseInt(card.attr('data-sale-ts'), 10);
            let placed = false;
            if (ts) {
                list.find('.sale-record').each(function () {
                    const otherTs = parseInt($(this).attr('data-sale-ts'), 10);
                    if (otherTs && otherTs > ts) {
                        card.insertBefore(this);
                        placed = true;
                        return false;
                    }
                });
            }
            placed || list.append(card);
        });

        const qty = list.find('.sale-record').length;
        if (!qty) {
            return;
        }
        const qtyText = qty > 1 ? window.aiDamageRecordsText : window.aiDamageRecordText;
        section.find('.js-sales-qty').text(qty);
        section.find('.js-sales-qty-text').text(qtyText || '');
        $('#outline a[href="#sales"] .txt').empty().append($('<b class="blc">').text(qty), ' ' + (qtyText || ''));
        section.show();
        $('a[href="#sales"]').closest('li.d-none').removeClass('d-none');
        $('body').scrollspy('refresh');
        initDamage3d();
    };

    const poll = () => {
        $.ajax({
            method: 'POST',
            url: window.aiDamageUrl,
            data: {reportId: reportId},
            success: (response) => {
                if (response.denied) {
                    settle();
                    return;
                }
                if (response.ready) {
                    response.html && insert(response.html);
                    settle();
                    return;
                }
                if (++tries < 42) {
                    setTimeout(poll, tries < 30 ? 2000 : 5000);
                    return;
                }
                settle();
            },
            error: () => {
                if (++errors < 3) {
                    setTimeout(poll, 5000);
                    return;
                }
                settle();
            },
        });
    };
    poll();
});

$(() => {
    let header = $("#rep-nav");
    $(document).scroll(() => {
        let scroll = $(document).scrollTop();

        if (scroll >= 250) {
            header.addClass("sticky-outline");
        } else {
            header.removeClass("sticky-outline");
        }
    });
});

function showAllEquipment() {
    let maxHeight = 0;
    const equipmentList = document.getElementById('equipment-list');
    const equipmentListItems = Array.from(equipmentList.querySelectorAll('li'));
    const equipmentListItemsSlices = equipmentListItems.slice(0, 20);
    const buttonShowAllWrapper = document.querySelector('.equipment-show');
    const buttonShowAll = buttonShowAllWrapper.querySelector('button');

    if (equipmentListItems.length > 20) {
        buttonShowAllWrapper.classList.remove('d-none');

        for (const item of equipmentListItemsSlices) {
            maxHeight += item.offsetHeight;
        }

        equipmentList.style.maxHeight = maxHeight + 'px';
    }

    buttonShowAll.addEventListener('click', () => {
        if (buttonShowAllWrapper.classList.contains('open')) {
            buttonShowAllWrapper.classList.remove('open');
            equipmentList.style.maxHeight = `${maxHeight}px`;
        } else {
            buttonShowAllWrapper.classList.add('open');
            equipmentList.style.maxHeight = 'none';
        }
    });
}
